// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__Ca3eW","darkLink":"Link_darkLink__FGStY"};